exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".screenshotDataPage .adminIDs{height:120px;font-size:10px;margin-bottom:10px}.screenshotDataPage .studentRow .nameCell{letter-spacing:-2px;word-spacing:5px}.screenshotDataPage .progressWrap{display:inline-block;margin-bottom:28px}.screenshotDataPage .progressWrap .graphDescription{display:none}.screenshotDataPage .studentName{text-align:center}.screenshotDataPage .studentListName{text-align:center;font-size:1.6em;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/screenshot_data_page.scss
// module id = 816
// module chunks = 0